// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c95491c1","453":"764c958e","455":"d0f30e29","977":"669a3613"}[chunkId] + ".chunk.js";
};